import store from "@/core/store"

export default function (to, _from, next) {
  if (to.meta.module !== "travel") {
    return next()
  }

  const deterRegistry = store.state.auth.organization.deter_registry

  if (deterRegistry.mpsc) {
    return next("/")
  }

  next()
}
